// components/Header.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  AppBar, Toolbar, Typography, Box, InputBase,
  IconButton, Tooltip, Badge, Avatar, Menu, MenuItem, useMediaQuery
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { username,  branch } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);


  

  return (
    <AppBar
      position="fixed"
      sx={{
        background: 'linear-gradient(to left, #004e92, #000428)',
        zIndex: 1201,
        fontFamily: 'Poppins, Roboto, sans-serif',
        direction: 'ltr',
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
        {/* App title or branch info */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            fontSize: isMobile ? '1rem' : '1.4rem',
            color: '#fff',
            textAlign: 'center',
            flexGrow: 1,
          }}
        >
          Branch: {branch}
        </Typography>

        {/* User settings */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {username && (
            <>
              <Tooltip title="User settings">
                <Box
                  onClick={handleMenuOpen}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    backgroundColor: '#fff',
                    px: 1.5,
                    py: 0.5,
                    borderRadius: '999px',
                    cursor: 'pointer',
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#222', fontWeight: 'bold' }}>
                    {username}
                  </Typography>
                  <Avatar alt={username} src="/user.jpg" sx={{ width: 32, height: 32 }} />
                </Box>
              </Tooltip>

              <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem disabled>
                 
                  </MenuItem>
               
                   </Menu>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
